import React from "react";
import {LayoutMargins, Margin, MediaSpecific} from "../Layout";
import { PageContent, PageSection } from "../Page";
import { Typography, ImageCardList } from '@/components';
import clsx from "clsx";
import * as C from "@components";

interface ImageCardSectionProps extends React.ComponentProps<typeof ImageCardList>
{
    headingNode?: React.ReactNode;
    headingLeft?: boolean;
    headlineClassName?: string;
    headlineLayout?: MediaSpecific<LayoutMargins>;
    className?: string;
    isSubhead?: boolean;
    isSubheadList?: boolean;
}

export const ImageCardSectionKeys = [
    "key-benefits.headline",
    "key-benefits.subhead",
] as const;

export const ImageCardSection = ({ headingLeft, headingNode, headlineClassName, className, keyPrefix, pageContent, isSubhead, isSubheadList, headlineLayout, ...props }: ImageCardSectionProps): React.FunctionComponentElement<ImageCardSectionProps> =>
{
    const sectionClasses = clsx(
        className
    );


    const getSectionHeading = (): React.ReactNode =>
    {
        if (headingNode !== undefined)
        {
            return headingNode;
        }

        const content: React.ReactElement<any>[] = [];

        const addContent = (key: string, props?: Partial<React.ComponentProps<typeof PageContent>>) =>
        {
            const pageContentKey = `${keyPrefix}.${key}`;
            const pageContentItem = pageContent[pageContentKey];
            if (pageContentItem !== undefined)
            {
                content.push(<PageContent {...pageContentItem} {...props} key={pageContentKey} />);
            }
        }

        addContent("eyebrow", { layout: { all: { margins: { bottom: Margin.D20 } }, ipad: { margins: { bottom: Margin.D24 } } }, typography: Typography.H8, uppercase: true, centered: !headingLeft });
        addContent("headline", { layout: headlineLayout ?? { all: { margins: { bottom: Margin.D20 } }, ipad: { margins: { bottom: Margin.D84 } } }, typography: Typography.H2, centered: !headingLeft });

        return content;
    }

    const getSectionHeadingWithSubhead = (): React.ReactNode => {
        return !isSubheadList ? <C.SideBySideText
            pageContent={pageContent}
            keys={ImageCardSectionKeys}
            items={{
                "key-benefits.headline": { maxWidth: C.Width.W648 },
                "key-benefits.subhead": { margins: { left: C.Dimension.Auto, right: C.Dimension.Auto }, ...{ maxWidth: C.Width.W448 }},
            }}
            layout={{ all: { margins: { bottom: C.Margin.D40 } }, ipad: { margins: { bottom: C.Margin.D80 } } }}
        /> : <div className='text-center my-12 md:my-24 space-y-6'>
            <h2 className='max-w-[700px] mx-auto'>
                {pageContent["key-benefits.headline"]?.data ?? ""}</h2>
            <p className='text-2xl'>
                {pageContent["key-benefits.subhead"]?.data ?? ""}</p>
        </div>
    }

    return (
        <PageSection className={sectionClasses}>
            {isSubhead ? getSectionHeadingWithSubhead() : getSectionHeading()}
            <ImageCardList {...props} keyPrefix={keyPrefix} pageContent={pageContent}/>
        </PageSection>
    );
};
